interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "SVC";
};

const SVC: Currency = Object.freeze({
  "displayName": "El Salvador Colon",
  "numericCode": 222,
  "defaultFractionDigits": 2,
  "subUnit": 100,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "SVC",
  "symbol": "₡"
});

export { SVC };
